module.exports = "<div role=\"tabpanel\" class=\"tab-pane active\" v-show=\"show\"\n    :class=\"{hide:!show}\"\n    :transition=\"transition\"\n  >\n    <slot></slot>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@vue-html-loader!./~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/Tab.vue
// module id = 203
// module chunks = 0